"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.REGULAR_HEIGHT = exports.COLLAPSED_HEIGHT = void 0;
var _default = exports["default"] = {
  position: 'fixed',
  width: '50%',
  height: 500,
  maxHeight: '100%',
  // Don't want it overflowing the top in storyboard
  overflow: 'scroll',
  bottom: 0,
  left: 0,
  backgroundColor: 'whitesmoke',
  zIndex: 100,
  border: '3px mediumspringgreen solid',
  transition: '0.5s ease all',
  pointerEvents: 'auto',
  opacity: 1
};
var COLLAPSED_HEIGHT = exports.COLLAPSED_HEIGHT = 50;
var REGULAR_HEIGHT = exports.REGULAR_HEIGHT = 500;